var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarLogsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154491",
    "data-name": "Rectangle 154491",
    width: 13.871,
    height: 11.984,
    fill: "#61277f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187631",
    "data-name": "Group 187631",
    transform: "translate(-58 -483)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154492",
    "data-name": "Rectangle 154492",
    width: 21,
    height: 23,
    rx: 4,
    transform: "translate(58 483)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_187629",
    "data-name": "Group 187629",
    transform: "translate(62 489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187629-2",
    "data-name": "Group 187629",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37733",
    "data-name": "Path 37733",
    d: "M66.9,5.964A2.982,2.982,0,1,1,69.887,3,2.987,2.987,0,0,1,66.9,5.964",
    transform: "translate(-60.942 0)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37734",
    "data-name": "Path 37734",
    d: "M6.684,160.011l-.626.636a2.223,2.223,0,0,0-.118,3c.192.225.414.425.622.637.038.039.074.081.131.143H.014c0-.055-.009-.11-.009-.165,0-.4.011-.792,0-1.187A1.733,1.733,0,0,1,.54,161.76a4.513,4.513,0,0,1,1.6-1,10.321,10.321,0,0,1,4.152-.779c.125,0,.249.022.392.035",
    transform: "translate(0 -152.509)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37735",
    "data-name": "Path 37735",
    d: "M152.592,145.93a2.715,2.715,0,0,1,.177-.223q1.524-1.537,3.049-3.073a.77.77,0,0,1,.635-.268.714.714,0,0,1,.636.473.693.693,0,0,1-.152.775c-.263.279-.539.547-.809.82l-2.951,2.974a.764.764,0,0,1-1.215-.006c-.483-.488-.967-.975-1.449-1.464a.74.74,0,1,1,1.053-1.04l1.025,1.033",
    transform: "translate(-143.277 -135.721)",
    fill: "#61277f"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogsActive);
export default __webpack_public_path__ + "static/media/sidebar-logs-active.9456186f0b0666734868126157f45234.svg";
export { ForwardRef as ReactComponent };